function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M837.863 552.215H95.229a24.9 24.9 0 01-24.9-24.901q403.806-46.93 792.435 0a24.9 24.9 0 01-24.901 24.9z",
  fill: "#ccc"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M862.764 528.779l-792.436-1.465 91.841-154.532.44-.733V31.478A31.475 31.475 0 01194.085 0h540.526a31.475 31.475 0 0131.478 31.478v342.915z",
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M193.368 21.971a10.265 10.265 0 00-10.253 10.254v310.529a10.265 10.265 0 0010.253 10.253h546.356a10.266 10.266 0 0010.253-10.253V32.224a10.265 10.265 0 00-10.253-10.253z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M196.959 394.02a4.406 4.406 0 00-3.992 2.558l-28.3 61.52a4.394 4.394 0 003.992 6.231h595.112a4.394 4.394 0 003.929-6.36l-30.76-61.52a4.372 4.372 0 00-3.93-2.428z",
  fill: "#ccc"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 464.349,
  cy: 10.253,
  r: 6.591,
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M405.854 476.047a4.401 4.401 0 00-4.242 3.252l-7.099 26.365a4.394 4.394 0 004.243 5.537h134.997a4.393 4.393 0 004.152-5.831l-9.127-26.366a4.397 4.397 0 00-4.152-2.957zM766.09 366.922v5.86H162.169l.454-.733v-5.127H766.09zM691.547 380.344a1.072 1.072 0 00-1.033.792l-1.728 6.42a1.07 1.07 0 001.033 1.349h32.874a1.07 1.07 0 001.01-1.42l-2.222-6.421a1.07 1.07 0 00-1.011-.72zM643.547 380.344a1.072 1.072 0 00-1.033.792l-1.728 6.42a1.07 1.07 0 001.033 1.349h32.874a1.07 1.07 0 001.01-1.42l-2.222-6.421a1.07 1.07 0 00-1.011-.72z",
  fill: "#ccc"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M504.481 421.14h2.577L501.905 76.75h-2.577l.103 6.87-57.747.001.103-6.87h-2.576l-5.153 344.388h2.576l.334-22.33h67.18zm-3.713-248.2h-60.42l.63-42.083h59.16zm.038 2.576l.63 42.082H439.68l.63-42.082zm.668 44.659l.63 42.082h-63.092l.63-42.082zm.669 44.659l.63 42.082h-64.43l.63-42.082zm.668 44.659l.63 42.082h-65.766l.63-42.082zM499.47 86.198l.63 42.083h-59.084l.63-42.083zm-62.463 310.036l.63-42.083h65.842l.63 42.083z",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 457.794,
  cy: 153.358,
  r: 42.012,
  fill: "#2f2e41"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M469.947 184.665l12.56-2.274 4.073 22.502-12.56 2.273zM444.83 189.212l12.558-2.274 4.074 22.502-12.56 2.273z"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 613.672,
  cy: 387.298,
  rx: 10.636,
  ry: 3.989,
  transform: "rotate(-40.261 296.132 519.53)",
  fill: "#2f2e41"
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 638.267,
  cy: 382.846,
  rx: 10.636,
  ry: 3.989,
  transform: "rotate(-40.261 320.726 515.077)",
  fill: "#2f2e41"
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  cx: 454.853,
  cy: 143.081,
  r: 14.359,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 448.952,
  cy: 137.934,
  r: 4.786,
  fill: "#3f3d56"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M490.936 107.653c.632-15.554-12.773-28.728-29.94-29.425s-31.597 11.346-32.23 26.9 11.303 19.087 28.47 19.784 33.068-1.706 33.7-17.26z",
  fill: "#7ebc89"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 579.682,
  cy: 319.596,
  rx: 6.594,
  ry: 21.006,
  transform: "rotate(-77.09 390.211 333.489)",
  fill: "#2f2e41"
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 662.15,
  cy: 333.311,
  rx: 6.594,
  ry: 21.006,
  transform: "rotate(-77.09 472.68 347.203)",
  fill: "#2f2e41"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M469.333 169.914a9.572 9.572 0 11-18.835 3.429l-.004-.018c-.941-5.203 3.08-7.043 8.283-7.985s9.614-.628 10.556 4.574z",
  fill: "#fff"
});

var _ref18 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 469.866,
  cy: 467.526,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-69.082 263.212 497.296)",
  fill: "#2f2e41"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 430.059,
  cy: 500.048,
  r: 43.067,
  transform: "rotate(-80.783 247.526 507.53)",
  fill: "#2f2e41"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M249.753 359.955h13.084v23.442h-13.084zM275.921 359.955h13.084v23.442h-13.084z"
});

var _ref21 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 260.656,
  cy: 383.67,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 286.824,
  cy: 383.125,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M227.602 286.104c-3.477-15.573 7.639-31.31 24.829-35.149s33.944 5.676 37.421 21.25-7.915 21.317-25.105 25.155-33.667 4.318-37.145-11.256z",
  fill: "#7ebc89"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 381.55,
  cy: 480.065,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-64.626 163.743 520.14)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("circle", {
  cx: 82.901,
  cy: 369.763,
  r: 43.067,
  fill: "#2f2e41"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M63.275 403.563h13.084v23.442H63.275zM89.443 403.563h13.084v23.442H89.443z"
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 74.178,
  cy: 427.277,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 100.346,
  cy: 426.732,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref29 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.991,
  cy: 358.86,
  r: 14.719,
  fill: "#fff"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.991,
  cy: 358.86,
  r: 4.906,
  fill: "#3f3d56"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M41.124 329.712c-3.477-15.574 7.639-31.31 24.829-35.149s33.944 5.675 37.421 21.249-7.915 21.318-25.105 25.156-33.667 4.318-37.145-11.256z",
  fill: "#e6e6e6"
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 268.669,
  cy: 387.383,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-69.082 62.015 417.153)",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("circle", {
  cx: 228.861,
  cy: 419.905,
  r: 43.067,
  transform: "rotate(-80.783 46.328 427.387)",
  fill: "#2f2e41"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M48.556 279.812H61.64v23.442H48.556zM74.723 279.812h13.084v23.442H74.723z"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 59.459,
  cy: 303.527,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref36 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 85.627,
  cy: 302.982,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.272,
  cy: 235.11,
  r: 14.719,
  fill: "#fff"
});

var _ref38 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.272,
  cy: 235.11,
  r: 4.906,
  fill: "#3f3d56"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M26.405 205.961c-3.478-15.573 7.639-31.31 24.828-35.149s33.945 5.676 37.422 21.25-7.915 21.317-25.105 25.155-33.668 4.318-37.145-11.256z",
  fill: "#7ebc89"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 180.353,
  cy: 399.922,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-64.626 -37.454 439.998)",
  fill: "#2f2e41"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M47.027 261.55c0 4.215 10.853 12.538 22.897 12.538s23.335-11.867 23.335-16.082-11.292.818-23.335.818-22.897-1.49-22.897 2.726z",
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M110.524 81.569a3.003 3.003 0 00-3 3v124a3.003 3.003 0 003 3h287a3.003 3.003 0 003-3v-124a3.003 3.003 0 00-3-3z",
  fill: "#7ebc89"
});

var _ref43 = /*#__PURE__*/React.createElement("circle", {
  cx: 188.018,
  cy: 146.569,
  r: 29.121,
  fill: "#fff"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 40",
  d: "M253.744 142.694a3.405 3.405 0 000 6.81h91.945a3.405 3.405 0 10.112-6.81h-.112zM253.744 122.967a3.405 3.405 0 000 6.81h45.915a3.405 3.405 0 10.112-6.81h-.112zM253.744 163.36a3.405 3.405 0 000 6.81h91.945a3.405 3.405 0 10.112-6.81h-.112z",
  fill: "#fff"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 853.282,
  cy: 546.503,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-20.918 301.938 894.773)",
  fill: "#2f2e41"
});

var _ref46 = /*#__PURE__*/React.createElement("circle", {
  cx: 884.09,
  cy: 588.025,
  r: 43.067,
  transform: "rotate(-9.217 -274.834 1497.71)",
  fill: "#2f2e41"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M743.035 447.932h-13.083l2.56 28.073 10.546-2.865-.023-25.208zM714.512 448.005h-13.084l2.56 28.073 10.07-2.938.454-25.135z"
});

var _ref48 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 863.998,
  cy: 647.212,
  rx: 10.903,
  ry: 4.089,
  transform: "rotate(-4.182 -1597.917 2760.883)",
  fill: "#2f2e41"
});

var _ref49 = /*#__PURE__*/React.createElement("circle", {
  cx: 722.319,
  cy: 403.229,
  r: 14.719,
  fill: "#fff"
});

var _ref50 = /*#__PURE__*/React.createElement("circle", {
  cx: 722.319,
  cy: 403.229,
  r: 4.906,
  fill: "#3f3d56"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 929.598,
  cy: 558.041,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-53.55 676.946 630.314)",
  fill: "#2f2e41"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M702.397 436.339c0-3.474 8.945-10.334 18.87-10.334s19.233 9.78 19.233 13.254-9.306-.674-19.232-.674-18.871 1.228-18.871-2.246z",
  fill: "#fff"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M844.177 378.542L608.43 345.86a7.008 7.008 0 01-5.972-7.895l26.502-191.172a7.008 7.008 0 017.894-5.973l235.746 32.682a7.008 7.008 0 015.972 7.894L852.072 372.57a7.008 7.008 0 01-7.895 5.973z",
  fill: "#7ebc89"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M759.722 318.88l-120.354-16.685a2.477 2.477 0 01-.445-.098l70.59-90.706a4.024 4.024 0 016.938.961l29.03 71.463 1.39 3.42z",
  fill: "#fff"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M826.735 328.17l-104.097-14.431 24.234-26.504 1.744-1.91 31.58-34.54a5.37 5.37 0 017.96.623 4.796 4.796 0 01.313.524z",
  fill: "#fff"
});

var _ref56 = /*#__PURE__*/React.createElement("circle", {
  cx: 761.186,
  cy: 224.184,
  r: 18,
  fill: "#fff"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  fill: "#3f3d56",
  d: "M640.876 155.517l21.792 3.022-3.021 21.791-21.792-3.02z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M765.187 374.08c3.477-15.573-7.64-31.31-24.83-35.148s-33.943 5.675-37.42 21.249 7.914 21.317 25.104 25.156 33.668 4.317 37.146-11.256z",
  fill: "#f2f2f2"
});

var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 892.69,
  cy: 647.142,
  rx: 10.903,
  ry: 4.089,
  transform: "rotate(-4.182 -1569.224 2760.814)",
  fill: "#2f2e41"
});

function SvgContentTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 878.64,
    height: 552.215
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    style: {
      isolation: "isolate"
    },
    d: "M759.722 318.879l-41.092-5.696 24.234-26.504 1.745-1.909.872-.955 1.391 3.42 12.85 31.644z"
  }), _ref55, _ref56, _ref57, _ref58, _ref59);
}

export default __webpack_public_path__ + "static/content-team.bbb1e517.svg";
export { SvgContentTeam as ReactComponent };